<div class="modal inmodal fade in parcel-modal parcel-transit-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" [ngClass]="{'ng-submitted': form.submitted}">
        <div class="modal-dialog"
             [ngStyle]="{'width': !((showResidentPhotoStatus || showReferenceSignatureStatus) &&
                                    ((action === 'pick_up' && parcel.isIncomingParcel()) || action === 'cancel')) ? '450px' : '650px'}">
            <div class="modal-content">
                <div class="receiver-info-section"
                     *ngIf="(showResidentPhotoStatus || showReferenceSignatureStatus) &&
                            ((action === 'pick_up' && parcel.isIncomingParcel()) || action === 'cancel')">
                    <div class="avatar-box">
                        <label class="circle-logo" *ngIf="showResidentPhotoStatus">
                            <img
                                [src]="(receiver && receiver.photo) || (cancellationResident && cancellationResident.photo) || 'assets/img/user-icon.png'"/>
                            <spinner [spinnerShow]="photoIsUpdating"></spinner>
                        </label>
                        <label *ngIf="showResidentPhotoStatus && canEditDirectory()"
                               class="delete-avatar clickable camera"
                               (click)="takeImageFromWebcam($event)">
                            <i class="fa fa-camera" aria-hidden="true"></i>
                        </label>
                        <img
                            *ngIf="showReferenceSignatureStatus && ((receiver && receiver.signature) || (cancellationResident && cancellationResident.signature))"
                            class="signature"
                            [src]="'data:image/png;base64,' + ((receiver && receiver.signature) || (cancellationResident && cancellationResident.signature))"/>
                        <div *ngIf="showReferenceSignatureStatus &&
                                    ((receiver && !receiver.signature) || (cancellationResident && !cancellationResident.signature))"
                             class="no-ref-sign">
                            No Reference Signature
                        </div>
                    </div>
                </div>
                <div class="modal-section">
                    <div class="modal-header">
                        <button type="button" class="close" (click)="hideModal()">
                            <span>×</span><span class="sr-only">Close</span>
                        </button>
                        <h4 *ngIf="action === 'pick_up'" class="modal-title">Parcel Pick Up</h4>
                        <h4 *ngIf="action === 'return'" class="modal-title">Parcel Return</h4>
                        <h4 *ngIf="action === 'cancel'" class="modal-title">Parcel Cancellation</h4>
                        <p>{{parcel.suiteNumber}} - {{parcel.buildingName}}</p>
                    </div>
                    <div class="modal-body">
                        <table class="table table-striped table-hover" *ngIf="data.length">
                            <thead>
                            <tr>
                                <th>
                                    <label class="img-checkbox" (click)="toggleCheckedAll()">
                                        <input type="checkbox" [checked]="isCheckedAll()">
                                        <label>
                                            <svg-checked></svg-checked>
                                        </label>
                                    </label>
                                </th>
                                <th>ID</th>
                                <th>Resident Name</th>
                                <th>Received</th>
                                <th>Pieces</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let item of data" (click)="item.checked = !item.checked">
                                <td>
                                    <label class="img-checkbox">
                                        <input type="checkbox" name="parcel_{{ item.id }}" [checked]="item.checked">
                                        <label>
                                            <svg-checked></svg-checked>
                                        </label>
                                    </label>
                                </td>
                                <td>{{item.parcelNumber}}</td>
                                <td>{{item.residentFullName}}</td>
                                <td>{{item.createdAt | mccDate:false:true }}</td>
                                <td>{{item.numberPieces}}</td>
                            </tr>
                            </tbody>
                        </table>

                        <div class="row m-b-xs p-sm">
                            <!--pick_up ----->
                            <div class="row" *ngIf="action === 'pick_up'">
                                <label class="col-sm-4 m-t-xs">Picked up by: </label>
                                <div class="col-sm-8" *ngIf="parcel.isIncomingParcel()">
                                    <select class="form-control"
                                            [ngModel]="parcel.residentId"
                                            (change)="onReceiverChange($event)"
                                            name="residentId" required #residentSelect>
                                        <option value="" hidden></option>
                                        <option *ngFor="let resident of residents" [value]="resident.id">
                                            {{resident.fullName}}
                                        </option>
                                        <option [value]="0">Other</option>
                                    </select>
                                    <input *ngIf="residentSelect.value == '0'"
                                           class="form-control"
                                           placeholder="Other Resident Name"
                                           [ngModel]="parcel.residentFullName"
                                           name="otherResident"
                                           maxlength="255" required>
                                </div>
                                <div class="col-sm-8" *ngIf="parcel.isOutgoingParcel()">
                                    <select class="form-control"
                                            name="pickedUpByPostService"
                                            required
                                            (change)="onReceiverChange($event)"
                                            [ngModel]="parcel.parcelPostServiceId || parcelsService.postServices[0].id">
                                        <option value="" hidden></option>
                                        <option *ngFor="let postService of parcelsService.postServices"
                                                [value]="postService.id">
                                            {{postService.name}}
                                        </option>
                                        <option value="-1">Other</option>
                                    </select>
                                    <input type="text"
                                           *ngIf="form.value.pickedUpByPostService == -1"
                                           class="form-control"
                                           placeholder="Other Courier"
                                           name="pickedUpByPostServiceName"
                                           [ngModel]="parcel.parcelPostServiceName">
                                </div>
                            </div>

                            <!--return ---->
                            <div class="row" *ngIf="action === 'return'">
                                <label class="col-sm-4 m-t-xs">Returning by: </label>
                                <div class="col-sm-8">
                                    <select class="form-control"
                                            name="returningBy"
                                            required
                                            [ngModel]="parcel.parcelPostServiceId || parcelsService.postServices[0].id">
                                        <option value="" hidden></option>
                                        <option *ngFor="let postService of parcelsService.postServices"
                                                [value]="postService.id">
                                            {{postService.name}}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <!--cancellation ----->
                            <div class="row" *ngIf="action === 'cancel'">
                                <label class="col-sm-4 m-t-xs">Cancelled By: </label>
                                <div class="col-sm-8">
                                    <select class="form-control"
                                            [ngModel]="parcel.residentId"
                                            name="residentId"
                                            (change)="onCancellationResidentChange($event)"
                                            required #residentSelect>
                                        <option value="" hidden></option>
                                        <option *ngFor="let resident of residents" [value]="resident.id">
                                            {{resident.fullName}}
                                        </option>
                                        <option [value]="0">Other</option>
                                    </select>
                                    <input *ngIf="residentSelect.value == '0'"
                                           class="form-control"
                                           placeholder="Other Resident Name"
                                           [ngModel]="parcel.residentFullName"
                                           name="otherResident"
                                           maxlength="255" required>
                                </div>
                            </div>
                            <div class="row detailed-view-body"
                                 *ngIf="(action === 'pick_up' || action === 'cancel') &&
                                        form.value.residentId && form.value.residentId !== '0'
                                        && ((action === 'pick_up' && receiver && !receiver.email) ||
                                        (action === 'cancel' && cancellationResident && !cancellationResident.email))
                                        && canEditDirectory() && !successfullyAddedEmail">
                                <div class="dv-label col-sm-4 m-t-xs">
                                    <label>Email:</label>
                                </div>
                                <div class="dv-value-edit col-sm-8">
                                    <input class="form-control" name="email" ngModel maxlength="255">

                                    <button type="button" (click)="updateResidentEmail()">
                                        <i class="fa fa-check"></i>
                                    </button>
                                </div>
                            </div>
                            <div *ngIf="successfullyAddedEmail" class="m-t-sm text-center">
                                Notification will be sent to {{successfullyAddedEmail}}
                            </div>
                            <div *ngIf="useSignaturePadStatus">
                                <div class="row m-t-md m-b-md">
                                    <div class="col-sm-4">
                                        <div class="input-radio">
                                            <input id="with-sign"
                                                   type="radio"
                                                   class="i-checks"
                                                   name="sign"
                                                   [(ngModel)]="signatureStatus"
                                                   [value]="1">
                                            <label for="with-sign">Signature</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-8" *ngIf="form.value.sign == 1">
                                        <signature-field name="signBase" [ngModel]="parcel.signBase"
                                                         [showSignModal]="true"></signature-field>
                                        <label for="isPatchReferenceSign"
                                               class="img-checkbox"
                                               *ngIf="action !== 'return' && showReferenceSignatureStatus &&
                                                     (receiver || cancellationResident) &&
                                                     (!parcel.isOutgoingParcel() || action === 'cancel')  &&
                                                     accountService.canRead('bldn')">
                                            <input type="checkbox" id="isPatchReferenceSign" name="isPatchReferenceSign"
                                                   [(ngModel)]="isPatchReferenceSignature">
                                            <label for="isPatchReferenceSign">
                                                <svg-checked></svg-checked>
                                            </label>
                                            Save as Reference
                                        </label>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-8">
                                        <div class="input-radio">
                                            <input id="without-sign"
                                                   type="radio"
                                                   class="i-checks"
                                                   name="sign"
                                                   [(ngModel)]="signatureStatus"
                                                   [value]="0">
                                            <label for="without-sign">Save Without Signature</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-4"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row text-center m-b-md">
                        <button type="submit"
                                class="btn btn-primary submit-btn"
                                [disabled]="!isSomeChecked() || disabledSubmit">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/parcels/transit-parcel-modal/transit-parcel-modal.component.html